<template>
  <div class="history-progress" v-if="show">
    <div class="history-progress-icon">
      <img :src="staticIcon || icon" :alt="title">
    </div>
    <div class="history-progress-info">
      <div class="history-progress-title flex-between">
        <a :href="link">{{title}}</a>
        <span>{{Math.round(time/60)}}m</span>
      </div>
      <div class="history-progress-line">
        <div class="history-progress-line-percent" :style="{width: time/maxSiteTime*100+'%'}"></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'HistoryProgress',
  props: ['domain', 'staticIcon', 'time', 'maxSiteTime'],
  computed: {
    show(){
      return this.domain !== 'undefined'
    },
    title() {
      return this.domain.replace(/\|/g, '.')
    },
    icon() {
      return 'https://www.google.com/s2/favicons?sz=64&domain=//' + this.title
    },
    link() {
      return 'https://' + this.title
    }
  }
}

</script>

<style lang="scss">
.history-progress {
  display: flex;
  padding-top: 14px;

  &-icon {
    width: 32px;
    height: 32px;
    margin-right: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &-info {
    border-bottom: 1px solid #ECE9F1;
    padding-bottom: 22px;
    width: calc(100% - 64px);
  }

  &:last-child .history-progress-info {
    border-bottom: 0;
  }

  &-title {
    font-weight: 600;
    margin-bottom: 6px;
    a {
      color: #27272c;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      max-width: calc(100% - 40px);
    }
  }

  &-line {
    position: relative;
    background: #EFF0F7;
    border-radius: 60px;
    width: 100%;
    height: 8px;

    &-percent {
      background: #FFAA2A;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      border-radius: 60px;
    }
  }

  &.-disabled {
    display: block;
    border-bottom: 1px solid #ece9f1;
    padding-bottom: 12px;

    &:last-child {
      border-bottom: 0;
    }

    .history-progress {
      &-icon {
        min-width: 14px;
        max-width: 14px;
        height: 14px;
        background: #EFF0F7;
        border-radius: 50%;
        margin-right: 10px;
      }

      &-title {
        width: 44px;
        height: 8px;
        background: #EFF0F7;
        border-radius: 8px;
      }

      &-value {
        color: #a0a8b1;
        font-size: 12px;
        font-weight: 600;
      }

      &-line {
        margin-top: 5px;
      }
    }
  }
}

.history-empty {
  position: relative;

  &-content {
    position: absolute;
    z-index: 2;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 22px;
    font-weight: 700;
    color: #515156;
  }
}
</style>
